import { Palette } from 'config';
import styled from 'styled-components';

export const Container = styled.div`
  margin-bottom: 24px;
  border: 1px solid ${Palette.PrimaryGray._200};
`;

export const ErrorContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  /* height: 579px; */
  height: 152px;
  margin-bottom: 24px;
  background-color: ${Palette.White._100};
  border: 1px solid ${Palette.PrimaryGray._200};
`;

export const StatisticBox = styled.div`
  position: relative;
  display: flex;
  width: 100%;
`;

export const LoaderWrap = styled.div`
  width: 100%;
  background-color: ${Palette.White._100};
  /* height: 579px; */
  height: 152px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 24px;
  border: 1px solid ${Palette.PrimaryGray._200};
`;
